var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from 'react';
import { CrossIcon, IconButton } from '@honeycomb/ui-core';
import { useGlobalContext, useModal, useRemoveHotelFromShortlist } from '@honeycomb/data';
export function WishlistRemoveButton({ estabId, onRemove, onRemoveError }) {
    const { resourceStrings: { APISUNSUBSCRIBEFAILHEADING, HC_ERROR_MSG }, } = useGlobalContext();
    const [_, setCurrentModal] = useModal();
    const [removeHotelFromShortlist] = useRemoveHotelFromShortlist([]);
    const handleRemove = useCallback((event) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        event.preventDefault();
        onRemove === null || onRemove === void 0 ? void 0 : onRemove();
        const removeData = yield removeHotelFromShortlist({
            variables: {
                estabId: parseInt(estabId),
            },
        });
        onRemoveError === null || onRemoveError === void 0 ? void 0 : onRemoveError();
        if (!((_b = (_a = removeData.data) === null || _a === void 0 ? void 0 : _a.removeHotelFromShortlist) === null || _b === void 0 ? void 0 : _b.success)) {
            setCurrentModal({
                isOpen: true,
                heading: APISUNSUBSCRIBEFAILHEADING,
                subheading: HC_ERROR_MSG,
            });
        }
    }), [
        APISUNSUBSCRIBEFAILHEADING,
        HC_ERROR_MSG,
        estabId,
        onRemove,
        onRemoveError,
        removeHotelFromShortlist,
        setCurrentModal,
    ]);
    return (React.createElement(IconButton, { shape: "circle", pos: "absolute", top: "16px", right: "16px", zIndex: 1, bg: "common.white", onClick: handleRemove },
        React.createElement(CrossIcon, { size: "s" })));
}
